'use es6';

import { createSelector } from 'reselect';

const getEndpointsState = state => state.endpoints;

export const getEndpointsStatus = createSelector([getEndpointsState], state => state.get('status'));
export const getEndpoints = createSelector([getEndpointsState], state => state.get('data'));